import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';

import { BackDropLoad } from './LoadingBackDrop';
import { UserContext, SnackbarContext } from './userContext';
import {
  AccountHeader,
  FormCard,
  Field,
  PrimaryButton,
  Icon,
} from './myacc/primitives';

export const MyAccUpdatePassword = () => {
  const history = useNavigate();
  const [curpass, setCurPass] = useState('');
  const [newpass, setNewPass] = useState('');
  const [newrepass, setNewRePass] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState(0);
  const [wait, setWait] = useState(false);

  const { user, setUser } = useContext(UserContext);
  const { setSnack } = useContext(SnackbarContext);

  const updatepass = (e) => {
    e.preventDefault();
    setError(0);
    if (curpass === '' || curpass.length < 3) {
      setError(1);
      setSnack({ message: 'Enter your current password.', type: 'error', open: true });
      return;
    }
    if (newpass === '' || newpass.length < 3) {
      setError(2);
      setSnack({ message: 'Enter a new password.', type: 'error', open: true });
      return;
    }
    if (newpass !== newrepass) {
      setError(3);
      setSnack({ message: 'Passwords do not match.', type: 'error', open: true });
      return;
    }

    setWait(true);
    Axios.post('/new_apis/changepass',
      { uid: user.user_id, curpass, newpass },
      { headers: { tkn: user.token } },
    ).then((res) => {
      const s = res.data.status;
      if (s === 1) {
        setWait(false);
        setCurPass(''); setNewPass(''); setNewRePass('');
        setSnack({ message: res.data.msg, type: 'success', open: true });
      } else if (s === 2) {
        setWait(false);
        setSnack({ message: res.data.msg, type: 'error', open: true });
      } else if (s === 3) {
        setWait(false);
        history('/');
        setSnack({ message: res.data.msg, type: 'error', open: true });
      } else if (s === 4) {
        setUser(null);
        setWait(false);
        localStorage.removeItem('estkn');
        history('/');
        setSnack({ message: res.data.msg, type: 'warning', open: true });
      }
    });
  };

  const eyeButton = (
    <button
      type="button"
      onClick={() => setShowPass((v) => !v)}
      aria-label={showPass ? 'Hide password' : 'Show password'}
      className="
        inline-flex h-7 w-7 items-center justify-center rounded-md
        text-fg-tertiary
        transition-colors duration-200
        hover:bg-surface-overlay hover:text-fg-primary
      "
    >
      {showPass ? <Icon.EyeOff className="h-4 w-4" /> : <Icon.Eye className="h-4 w-4" />}
    </button>
  );

  return (
    <>
      <BackDropLoad wait={wait} />
      <AccountHeader
        kicker="Security"
        title="Update password"
        subtitle="Change the password you use to sign in to ESAY."
      />

      <FormCard onSubmit={updatepass}>
        <div className="grid grid-cols-1 gap-3 sm:gap-4">
          <Field
            label="Current password"
            type={showPass ? 'text' : 'password'}
            value={curpass}
            onChange={(e) => setCurPass(e.target.value)}
            error={error === 1}
            errorMsg="Enter your current password."
            required
            autoComplete="current-password"
            icon={<Icon.Lock className="h-4 w-4" />}
            rightSlot={eyeButton}
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
            <Field
              label="New password"
              type={showPass ? 'text' : 'password'}
              value={newpass}
              onChange={(e) => setNewPass(e.target.value)}
              error={error === 2}
              errorMsg="Enter a new password."
              helper="At least 3 characters."
              required
              autoComplete="new-password"
              icon={<Icon.Lock className="h-4 w-4" />}
              rightSlot={eyeButton}
            />
            <Field
              label="Re-enter new password"
              type={showPass ? 'text' : 'password'}
              value={newrepass}
              onChange={(e) => setNewRePass(e.target.value)}
              error={error === 3}
              errorMsg="Passwords do not match."
              required
              autoComplete="new-password"
              icon={<Icon.Lock className="h-4 w-4" />}
              rightSlot={eyeButton}
            />
          </div>
          <div className="pt-1">
            <PrimaryButton type="submit" loading={wait} icon={<Icon.Save className="h-4 w-4" />}>
              {wait ? 'Saving…' : 'Update password'}
            </PrimaryButton>
          </div>
        </div>
      </FormCard>
    </>
  );
};
